import React, {useEffect} from 'react';
import {TrackingTargetProviderEnum, ViewContentCommandInput} from '@kidslabs/mario-client-event-tracking';
import {PageType} from '@/_application/core/types';
import useEventTrackingService from '@/_application/modules/tracking/service/event-tracking.service';
import isEqual from 'lodash/isEqual';
import {useSession} from 'next-auth/react';
import {Customer} from '@/__generated__/__types__';
import {generateCustomerInput} from '@/_application/modules/tracking/cdp/utils/input';

interface ViewContentTrackingProps {
    page: PageType;
    input: ViewContentCommandInput;
}
const ViewContentTracking = ({page, input}: ViewContentTrackingProps) => {
    const {trackViewContentEvent: trackGoogle} = useEventTrackingService(TrackingTargetProviderEnum.GOOGLE_ANALYTICS);
    const {trackViewContentEvent: trackFacebook} = useEventTrackingService(TrackingTargetProviderEnum.FACEBOOK_PIXEL);
    const {trackViewContentEvent: trackCdp} = useEventTrackingService(TrackingTargetProviderEnum.CDP);
    const {data: session} = useSession();
    const customer = session?.user as Customer;

    useEffect(() => {
        // Initialize window.kidsTracking.viewContents if it doesn't exist
        window.kidsTracking = window.kidsTracking || {};
        window.kidsTracking.viewContents = window.kidsTracking.viewContents || {};
        const inputIdentifier =
            'viewContentTracking_' + (input.content_name || input.content_category || input.contents?.[0]?.id);

        // Check if the content has already been tracked
        if (!window.kidsTracking.viewContents[inputIdentifier]) {
            // Mark the content as tracked
            window.kidsTracking.viewContents[inputIdentifier] = true;
            // Execute tracking events
            const trackEvents = async () => {
                const inputWithCustomerData = {
                    ...input,
                    customer: generateCustomerInput(customer),
                };

                await trackGoogle(inputWithCustomerData);
                await trackFacebook(inputWithCustomerData);
                await trackCdp(inputWithCustomerData);
            };
            trackEvents().then(() => {
                console.log('Tracked view content event');
            });
        }
    }, [page]);

    return <></>;
};

const arePropsEqual = (prevProps: ViewContentTrackingProps, nextProps: ViewContentTrackingProps) => {
    return (
        isEqual(prevProps.input.contents?.[0]?.id, nextProps.input.contents?.[0]?.id) && prevProps.page === nextProps.page
    );
};
const ViewContentTrackingComponent = React.memo(ViewContentTracking, arePropsEqual);

export {ViewContentTrackingComponent as ViewContentTracking};
